<template>
  <div>
    <SweetAlert ref="SweetAlert" />
    <div class="px-lg-5 px-md-3 px-sm-2 px-1 mt-2">
      <div class="d-flex title-option">
        <div class="btn-home mt-2 ms-auto">
          <button
            type="button"
            class="btn btn-outline-main"
            @click="mtdGetReportTurn()"
          >
            <i class="fas fa-table"></i> Ver Reporte
          </button>
          &nbsp;
          <button
            type="button"
            class="btn btn-outline-main"
            @click="returnHome()"
          >
            <i class="fas fa-home-lg-alt"></i> Inicio
          </button>
        </div>
      </div>

      <ul class="nav pb-0" id="myTab" role="tablist">
        <li
          v-if="page == 'cola' || page == 'pantalla'"
          class="nav-item"
          role="presentation"
        >
          <button
            @click="changePage('cola')"
            :class="{
              'item-button': true,
              'nav-link': true,
              active: page == 'cola',
            }"
            id="home-tab"
            type="button"
          >
            <strong>COLA</strong>
          </button>
        </li>
        <li
          v-if="page == 'cola' || page == 'pantalla'"
          class="nav-item"
          role="presentation"
        >
          <button
            @click="changePage('pantalla')"
            :class="{
              'item-button': true,
              'nav-link': true,
              active: page == 'pantalla',
            }"
            id="pantalla-tab"
            type="button"
          >
            <strong>ENVIAR PANTALLA</strong>
          </button>
        </li>
        <li v-if="page == 'historia'" class="nav-item" role="presentation">
          <button
            @click="changePage('historia')"
            :class="{
              'item-button': true,
              'nav-link': true,
              active: page == 'historia',
            }"
            id="profile-tab"
            type="button"
          >
            <strong>H. CLÍNICA</strong>
          </button>
        </li>
      </ul>

      <div
        class="tab-content px-lg-3 px-md-2 px-sm-2 px-1 mb-3"
        id="myTabContent"
      >
        <Cola
          v-if="page == 'cola'"
          @mtdHistorial="mtdHistorial"
          @mtdHistorialtable="mtdHistorialtable"
          :rolname="rolname"
        />
        <Pantalla v-if="page == 'pantalla'" :rolname="rolname" />
        <Historia
          v-if="page == 'historia'"
          :rolname="rolname"
          :typeDoctor="type"
          @changePage="changePage"
          :newhistorial="newhistorial"
          :newhistorialtable="newhistorialtable"
          :viewInput="viewInput"
          :stateHistoryShow="stateHistory"
          @validation="validation"
          @vaciarpatient="vaciarpatient"
          @updateOrigin="originHistoria = $event"
        />
      </div>
    </div>
    <cModalReportTurn
      :title="modalTurn.title"
      :boo_modal="modalTurn.boo_modal"
      @closeModalReport="closeModalReport"
      :report="modalTurn.report"
      @commitReport="commitReport"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Cola from "@/components/Asistencial/Hospitalizacion/ColaH.vue";
import Pantalla from "@/components/Asistencial/Hospitalizacion/PantallaH.vue";
import Historia from "@/components/Asistencial/Hospitalizacion/HistoriaH.vue";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";
import cModalReportTurn from "@/components/Asistencial/Hospitalizacion/modals/cModalReportTurn.vue";

export default {
  name: "c-asistencial-hospitalizacion",
  components: {
    Cola,
    Pantalla,
    Historia,
    SweetAlert,
    cModalReportTurn,
  },
  data() {
    return {
      swal: null,
      originHistoria: false,
      page: "cola",
      stateHistory: null,
      viewInput: null,
      newhistorial: {},
      newhistorialtable: {},
      /**reporte de turno */
      report: null,
      modalTurn: {
        boo_modal: false,
        title: "Reporte de Turno",
        report: [],
        report_id: null,
      },
    };
  },
  props: {
    patientold: {
      type: Object,
    },
    rolname: String,
    type: Number,
  },
  watch: {
    patientold: {
      handler: function (newValue) {
        if (newValue && Object.keys(newValue).length > 0) {
          this.indexhistory(newValue);
        } else {
          this.changePage2("cola");
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    ...mapActions(["get", "post"]),
    mtdGetStyle: function (option) {
      if (option == this.page) return "background: #900052";
      return "";
    },
    mtdGetStyleSpan: function (option) {
      if (option == this.page) return "color:white";
      return "";
    },
    changePage: function (page) {
      if (
        Object.keys(this.newhistorial).length == 0 &&
        Object.keys(this.newhistorialtable).length == 0
      ) {
        this.page = page;
        this.stateHistory = page == "historia" ? 1 : 0;
        this.viewInput = page == "historia" ? 1 : 0;
        this.newhistorial = {};
        this.newhistorialtable = {};
      }
    },
    changePage2: function (page) {
      this.page = page;
      this.stateHistory = page == "historia" ? 1 : 0;
      this.viewInput = page == "historia" ? 1 : 0;
      this.newhistorial = {};
      this.newhistorialtable = {};
    },
    vaciarpatient: function () {
      this.$emit("mtdFinish");
    },
    returnHome() {
      //window.location.reload();
      if (this.page == "historia" && this.originHistoria) {
        this.$refs.SweetAlert.showWarning(
          "Debe guardar el Historial Clínico antes de salir."
        );
        return;
      }
      this.$emit("mtdChangePage", "home");
    },
    mtdHistorial: function (payload) {
      this.page = "historia";
      this.newhistorial = payload;
      this.$emit("mtdpacienteold", payload);
    },
    mtdHistorialtable: function (payload, num) {
      this.page = "historia";
      this.newhistorialtable = payload;
      if (num != 1) {
        this.$emit("mtdpaciente", payload);
      }
    },
    validation: function (payload) {
      this.$emit("mtdpaciente", payload);
    },
    indexhistory: function (payload) {
      this.get({
        url:
          this.$store.getters.get__url +
          "/Hospitalization/history/" +
          payload.patient.medical_act_id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          let newhistory = response.data;
          this.mtdHistorialtable(
            {
              patient: newhistory,
            },
            1
          );
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    /** reporte de turno */
    mtdGetReportTurn: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/Hospitalization/getReportDay/" +
          this.$store.getters.get__user.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.modalTurn.boo_modal = true;
            this.modalTurn.title = `Reporte de Turno  ${this.obtenerTurno(
              response.data.created_at
            )}`;
            this.modalTurn.report = JSON.parse(response.data.report);
            this.modalTurn.report_id = response.data.id;
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    closeModalReport: function () {
      this.modalTurn = {
        boo_modal: false,
        title: "Reporte de Turno",
      };
    },
    obtenerTurno: function (fecha) {
      const hora = new Date(fecha).getHours();
      if (hora >= 5 && hora < 12) {
        return "mañana";
      } else if (hora >= 12 && hora < 18) {
        return "tarde";
      } else {
        return "noche";
      }
    },
    commitReport: function (report, option) {
      this.post({
        url: this.$store.getters.get__url + "/Hospitalization/storeReportDay",
        token: this.$store.getters.get__token,
        params: {
          id: this.modalTurn.report_id,
          report: report,
          option: option,
        },
      })
        .then(async (response) => {
          console.log(response);
          if (response.statusCode == 200) {
            this.$refs.SweetAlert.showSuccess("Reporte guardado correctamente");
            this.closeModalReport();
          }
        })
        .catch((errors) => {
          console.log(errors);
          this.$refs.SweetAlert.showError("Error al guardar el reporte");
        });
    },
  },
};
</script>